import React from 'react';
import MetricLinksDialog from '../../shared/components/MetricLinksDialog';

const CATALOGS = {
  client: {
    label: 'Clienti', singular: 'cliente', plural: 'clienti', iconKey: 'nav.clients', action: 'Apri cliente',
    name: (party) => party.name || party.company || 'Cliente',
    description: (party) => party.company,
  },
  supplier: {
    label: 'Fornitori', singular: 'fornitore', plural: 'fornitori', iconKey: 'nav.suppliers', action: 'Apri fornitore',
    name: (party) => party.displayName || party.legalName || 'Fornitore',
    description: (party) => party.category,
  },
  staff: {
    label: 'Team', singular: 'membro del team', plural: 'membri del team', iconKey: 'nav.team', action: 'Apri membro del team',
    name: (party) => party.name || 'Membro del team',
    description: (party) => party.role,
  },
};

export default function PartyActivityMetricDialog({ kind, activity, onSelect }) {
  const catalog = CATALOGS[kind];
  const count = activity.dialogItems.length;
  return (
    <MetricLinksDialog
      isOpen={Boolean(activity.dialogMetric)}
      onClose={activity.closeDialog}
      title={activity.dialogMetric?.label || catalog.label}
      subtitle={activity.dialogReady ? `${count} ${count === 1 ? catalog.singular : catalog.plural}` : catalog.label}
      iconKey={catalog.iconKey}
      items={activity.dialogItems}
      getItemLabel={catalog.name}
      getItemDescription={catalog.description}
      itemActionLabel={catalog.action}
      onSelect={(party) => { activity.closeDialog(); onSelect(party); }}
      emptyMessage={`Nessun ${catalog.singular} corrisponde alla metrica selezionata.`}
      statusMessage={activity.loading ? 'Caricamento attività...' : !activity.dialogReady ? 'Dati non disponibili per questa metrica.' : ''}
      className="party-activity-metric-dialog"
    />
  );
}
